import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={5}
    fill="none"
    viewBox="0 0 8 5"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M7.413.65 4.186 3.877a.26.26 0 0 1-.372 0L.588.65"
    />
  </svg>
);
export default SvgStreamlineChevronDown;
